module.exports = __webpack_public_path__ + "static/img/productPartner_3_1.49cad38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/productPartner/productPartner_3_1.png
// module id = Zfar
// module chunks = 34